import React, { useEffect, useState } from 'react';
import api from '../../utils/axios';
import CasoTimeline from './CasoTimeline';
import { digitos } from './episodioUtils';

// F5: timeline del caso + eventos del cliente (altas y cambios de CVU o sponsor, episodios) + casos absorbidos.
export const CasoLineaTiempoTab = ({ caso, eventosAbsorbidos }) => {
  const cuit = [digitos(caso.cuit), digitos(caso.cliente_key)].find((x) => x.length === 11);
  const [eventosCliente, setEventosCliente] = useState([]);
  useEffect(() => {
    if (!cuit) return undefined;
    let vivo = true;
    api.get(`/padron-interno/cliente/${cuit}/timeline`, { params: { solo_cliente: true } })
      // El cierre de un episodio de este caso ya figura en la línea de tiempo del caso: no se repite.
      .then((r) => vivo && setEventosCliente((r.data.eventos || [])
        .filter((e) => !(e.tipo === 'EPISODIO_CERRADO' && e.caso_id === caso.id)).map((e, i) => ({
        id: `cliente-${e.tipo}-${i}`, tipo: e.tipo, descripcion: e.texto, fecha: e.fecha,
      }))))
      .catch(() => vivo && setEventosCliente([]));
    return () => { vivo = false; };
  }, [cuit, caso.id]);
  return <CasoTimeline caso={caso} eventosAbsorbidos={eventosAbsorbidos} eventosCliente={eventosCliente} />;
};

export default CasoLineaTiempoTab;
